import type { IGlobalNotificationProps } from "../components/ui/notification/GlobalNotification";
import type { ReactNode } from "react";

import { toast, Zoom, type ToastOptions } from "react-toastify";

import GlobalNotification from "../components/ui/notification/GlobalNotification";

const DEFAULT_AUTO_CLOSE = 3000;

const NOTIFICATION_DEFAULT_OPTIONS: ToastOptions = {
  autoClose: DEFAULT_AUTO_CLOSE,
  className: "p-0",
  transition: Zoom,
  position: "bottom-center",
  closeButton: false,
  hideProgressBar: true,
  pauseOnHover: false,
  pauseOnFocusLoss: false,
};

export interface INotifyParams {
  msg: ReactNode | undefined;
  delay?: number;
  icon?: ReactNode;
}

export const notify = (
  type: IGlobalNotificationProps["type"],
  { msg, delay, icon }: INotifyParams
) => {
  if (!msg) {
    return;
  }

  const options: ToastOptions = {
    ...NOTIFICATION_DEFAULT_OPTIONS,
    autoClose: delay ?? DEFAULT_AUTO_CLOSE,
    toastId: `${type}-${String(msg)}`,
  };

  toast(
    ({ closeToast }) =>
      GlobalNotification({
        type,
        message: msg,
        closeToast,
        customIcon: icon,
      }),
    options
  );
};
